// TODO: Legacy component remove after useImprovedBrand FF removed
import I18n from 'i18n-js'
import { memo, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import Billboards from '@src/components/content/Billboards'
import RetailerAccountTaskListAlerts from '@src/components/taskList/RetailerAccountTaskListAlerts'

import breakpoints from '../../lib/Breakpoints'
import { selectors } from '../../stores'
import FeaturedAdHandler from '../FeaturedAdHandler'
import FPPAPModalRoute from '../FPPAPModalRoute'
import IGAutomationDialog from '../shared/IGAutomation/IGAutomationDialog'
import MessageBar from '../shared/MessageBar'

import { legacyCampaignContentPaths } from './campaignContentPaths'
import ContentDiscovery from './ContentDiscovery'
import OrganicCampaigns from './OrganicCampaigns'
import LegacyPaidAdCampaigns from './PaidAdCampaigns'

export const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
`

export const View = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  max-width: 1200px;
  margin: 0 auto;
  @media (min-width: ${breakpoints.tablet}) {
    padding: 24px;
  }
`
const ContentView = () => {
  const { expiringAd } = useSelector(
    selectors.paidAds.selectAdWithStartDateLessThanTwoDays,
  )
  const { id, brandName } = expiringAd || {}

  const [isIGAutomationDialogOpen, setIsIGAutomationDialogOpen] =
    useState(false)
  const params = legacyCampaignContentPaths.index.useParams()

  const { retailerAccountSlug, brandSlug } = params

  return (
    <Wrapper>
      {id && brandName && (
        <MessageBar
          isDismissable
          link={legacyCampaignContentPaths.activatePaidCampaign.build({
            retailerAccountSlug,
            brandSlug,
            campaignId: id,
          })}
          linkText={I18n.t('content.viewCampaign')}
          text={I18n.t('content.expiringCredits', { brandName })}
          type={'warning'}
        />
      )}
      <RetailerAccountTaskListAlerts />
      <>
        <View>
          <Billboards
            setIsIGAutomationDialogOpen={setIsIGAutomationDialogOpen}
          />
          <FeaturedAdHandler />
          <LegacyPaidAdCampaigns />
          <OrganicCampaigns />
          <ContentDiscovery />
        </View>

        <FPPAPModalRoute
          path={legacyCampaignContentPaths.activatePaidCampaign.path}
        />
        {isIGAutomationDialogOpen && (
          <IGAutomationDialog
            open={isIGAutomationDialogOpen}
            onClose={() => {
              setIsIGAutomationDialogOpen(false)
            }}
          />
        )}
      </>
    </Wrapper>
  )
}

export default memo(ContentView)
